export const TERMS_PRIVACY_LOADING = "TERMS_PRIVACY_LOADING";
export const GET_POLICIES = "GET_POLICIES";
export const REMOVE_TERMS_PRIVACY_DATA = "REMOVE_TERMS_PRIVACY_DATA";
